import { DARK_MODE } from "./dark-mode";

export const Apple = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <path
      d="M11.0791 0C11.1164 0 11.1536 0 11.1929 0C11.2843 1.12835 10.8536 1.97146 10.3302 2.582C9.81657 3.18834 9.11328 3.7764 7.9758 3.68717C7.89992 2.57498 8.33131 1.79441 8.85403 1.18526C9.33881 0.617573 10.2276 0.112414 11.0791 0Z"
      fill="black"
    />
    <path
      d="M14.5225 11.7444C14.5225 11.7557 14.5225 11.7655 14.5225 11.776C14.2028 12.7442 13.7468 13.574 13.1904 14.344C12.6824 15.0431 12.0599 15.9838 10.9484 15.9838C9.988 15.9838 9.35005 15.3663 8.36573 15.3494C7.32449 15.3325 6.75188 15.8658 5.79988 16C5.69098 16 5.58208 16 5.47529 16C4.77621 15.8988 4.21203 15.3452 3.80102 14.8463C2.58906 13.3723 1.65251 11.4683 1.47827 9.03174C1.47827 8.79286 1.47827 8.55469 1.47827 8.31581C1.55204 6.57199 2.39936 5.15417 3.52561 4.46704C4.12 4.10169 4.9371 3.79045 5.84695 3.92956C6.23689 3.98998 6.63526 4.12347 6.98444 4.25556C7.31536 4.38273 7.72918 4.60826 8.12123 4.59631C8.3868 4.58859 8.65098 4.45018 8.91866 4.35252C9.70275 4.06937 10.4714 3.74478 11.4845 3.89724C12.7021 4.08132 13.5663 4.62231 14.1002 5.45698C13.0702 6.1125 12.2559 7.10033 12.3951 8.78724C12.5187 10.3196 13.4096 11.2161 14.5225 11.7444Z"
      fill="black"
    />
  </svg>
);
